import {updateBasketPrice} from "./updateBasketPrice";

function updateBasketTotal(total) {
    updateBasketPrice('.checkout-total', total);
    updateBasketPrice('.checkout-basket-total', total);
}

export {updateBasketTotal}